import { Mail, Linkedin } from "lucide-react";

const Contact = () => (
  <div className="text-center max-w-3xl mx-auto">
    <p className="text-slate-400 leading-relaxed mb-10">
      Whether it’s architecting a lakehouse on one cloud or integrating across many, I love solving real data problems through clear, scalable engineering.
     <br />
     <br />
      If you’re working on data modernization, real-time ingestion, or governance automation, I’d love to exchange ideas..
    </p>

    <div className="flex justify-center gap-4">
      <a
        href="mailto:devishmundra@gmail.com"
        className="flex items-center gap-2 px-6 py-2 rounded-full bg-gradient-to-r from-brand-teal via-brand-blue to-brand-violet text-white shadow-md hover:shadow-[0_0_15px_rgba(75,95,255,0.35)] transition-transform duration-300 hover:scale-105"
      >
        <Mail className="w-4 h-4" /> Email Me
      </a>

      <a
        href="https://www.linkedin.com/in/devish-mundra-8599b01bb/"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 px-6 py-2 rounded-full bg-gradient-to-r from-[#4b5fff] to-[#b45eff] text-white shadow-md hover:shadow-[0_0_15px_rgba(75,95,255,0.3)] transition-transform duration-300 hover:scale-105"
      >
        <Linkedin className="w-4 h-4" /> LinkedIn
      </a>
    </div>
  </div>
);

export default Contact;
